import { render, staticRenderFns } from "./InventoryLossRecord.vue?vue&type=template&id=4452f478&scoped=true"
import script from "./InventoryLossRecord.vue?vue&type=script&lang=js"
export * from "./InventoryLossRecord.vue?vue&type=script&lang=js"
import style0 from "./InventoryLossRecord.vue?vue&type=style&index=0&id=4452f478&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452f478",
  null
  
)

export default component.exports